import { processAsJson } from '@utils/miscellaneous/processAsJson';

export const useNavigation = pushToHistory => {

    const navigateToLocation = () => {
        const navigationItem = sessionStorage.getItem('navigation');
        const { destination } = navigationItem ? processAsJson(navigationItem) : {};
        if (typeof destination === 'string') {
            sessionStorage.removeItem('navigation');
            pushToHistory(destination);
        }
    };

    return {
        navigateToLocation
    };
};